import { createEffect, createEvent } from 'effector'

import { APIResult, AxiosError } from '../../core/api/Result'
import {
  GetImportUserLoginReq,
  GetReferralStatisticsReq,
  GetReferralsReq,
  GetSearchReq,
  GetUsersByGeoReq,
  GetUsersPreviewsReq,
  PatchPassportReq,
  PatchPasswordReq,
  PostMyEmailReq,
  PostPassportReq,
  PostVerificationReq,
  PutParentReq,
  Referral,
  UserAPI,
} from '../../services/api/User'
import { Common, Routes } from '../../shared/enum'
import { $navigate } from '../History/store'

export const clearUsersPreviews = createEvent()
export const setReferralsTree = createEvent<Record<string, Referral[]>>()
export const setReferralsTreeCount = createEvent<number>()

export const getMyFx = createEffect(UserAPI.getMy)
export const patchMyFx = createEffect(UserAPI.patchMy)
export const postMyEmailFx = createEffect<PostMyEmailReq, APIResult<typeof UserAPI['postMyEmail']>, AxiosError>(UserAPI.postMyEmail)

export const getPassportFx = createEffect<unknown, APIResult<typeof UserAPI['getPassport']>, AxiosError>(
  UserAPI.getPassport,
)
export const postPassportFx = createEffect<PostPassportReq, APIResult<typeof UserAPI['postPassport']>, AxiosError>(
  UserAPI.postPassport,
)

export const patchPassportFx = createEffect<PatchPassportReq, APIResult<typeof UserAPI['patchPassport']>, AxiosError>(
  UserAPI.patchPassport,
)

export const postVerificationFx = createEffect<PostVerificationReq, APIResult<typeof UserAPI['postVerification']>, AxiosError>(
  UserAPI.postVerification,
)

export const getStatsFx = createEffect<unknown, APIResult<typeof UserAPI['getStats']>, AxiosError>(
  UserAPI.getStats,
)

export const getReferralsFx = createEffect<GetReferralsReq, APIResult<typeof UserAPI['getReferrals']>, AxiosError>(
  UserAPI.getReferrals,
)

export const getGeoStatsFx = createEffect<unknown, APIResult<typeof UserAPI['getUsersGeoStats']>, AxiosError>(
  UserAPI.getUsersGeoStats,
)

export const getPublicGeoStatsFx = createEffect<unknown, APIResult<typeof UserAPI['getUsersGeoStatsPublic']>, AxiosError>(
  UserAPI.getUsersGeoStatsPublic,
)

export const getUsersByGeoFx = createEffect<GetUsersByGeoReq, APIResult<typeof UserAPI['getUsersByGeo']>, AxiosError>(
  UserAPI.getUsersByGeo,
)

export const getMyReferralsFx = createEffect(UserAPI.getReferrals)

export const getReferralStatisticsFx = createEffect<GetReferralStatisticsReq, APIResult<typeof UserAPI['getReferralStatistics']>, AxiosError>(
  UserAPI.getReferralStatistics,
)

export const getUsersPreviewsFx = createEffect<GetUsersPreviewsReq, APIResult<typeof UserAPI['getUsersPreviews']>, AxiosError>(
  UserAPI.getUsersPreviews,
)

export const getSearchReferralFx = createEffect<GetSearchReq, APIResult<typeof UserAPI['getSearch']>, AxiosError>(
  UserAPI.getSearch,
)

export const clearSearchReferralFx = createEvent()

export const putParentFx = createEffect<PutParentReq, APIResult<typeof UserAPI['putParent']>, AxiosError>(
  UserAPI.putParent,
)

export const patchPasswordFx = createEffect<PatchPasswordReq, APIResult<typeof UserAPI['patchPassword']>, AxiosError>(
  UserAPI.patchPassword,
)

export const getImportUserLoginFx = createEffect<GetImportUserLoginReq, APIResult<typeof UserAPI['getImportUserLogin']>, AxiosError>(
  UserAPI.getImportUserLogin,
)

export const getAuthFx = createEffect(UserAPI.getAuth)
export const putReLoginDeviceFx = createEffect(UserAPI.putReLoginDevice)
export const putReLoginAllDeviceFx = createEffect(UserAPI.putReLoginAllDevice)

export const postInviteLinkFx = createEffect(UserAPI.postInviteLink)

export const getMyStoriesFx = createEffect(UserAPI.getMyStories)
export const setViewedStoriesFx = createEvent<number>()

const watch = [
  postVerificationFx,
  patchPassportFx,
  postPassportFx,
  putParentFx,
]

watch.forEach((fn) => {
  fn.done.watch(() => {
    getPassportFx(null)
    getMyFx()
  })
})

getImportUserLoginFx.done.watch(({ result }) => {
  const navigate = $navigate.getState()
  navigate(`/${Common.DEFAULT_LANGUAGE}/${Routes.AUTH}?${Common.REFERRAL_LINK}=${result.data.data.id}`)
})
getImportUserLoginFx.fail.watch(() => {
  const navigate = $navigate.getState()
  navigate(`/${Common.DEFAULT_LANGUAGE}/${Routes.AUTH}`)
})

putReLoginDeviceFx.done.watch(() => {
  getAuthFx()
})
putReLoginAllDeviceFx.done.watch(() => {
  getAuthFx()
})
